import React, { useState } from 'react';
import { useGlobalStore } from '../../store/globalStore';
import NotFind from './notfind';
import infoIcon from '../../assets/images/info.svg';
import ComputerIcon from '../../assets/images/computer.svg';
import SyncIcon from '../../assets/images/sync.svg';
import WebIcon from '../../assets/images/web.svg';
import bgRingIcon from '../../assets/images/c-bg-ring.svg';
import SyncPlayerIcon from '../../assets/images/sync-player.svg';
import CloudIcon from '../../assets/images/cloud.svg';
import PccIcon from '../../assets/images/csm_icon_app.png';
import axiosInstance from '../../axiosConfig';
import { useDialogStore } from '../../store/dialogStore';
import { formatDate } from '../../utils/utils';

import LeagueReportEvents from './LeagueReportEvents';

const LeagueEvents: React.FC<{
  data?: {
    title: string;
    registrationId: number;
    location?: string;
    number_country: string;
    date_start: string;
    date_end: string;
    gender: string;
    events: {
      id: number;
      name: string;
      date: string;
      number: number;
      category: string;
    }[];
  };
}> = ({ data }) => {
  const isLoading = useGlobalStore((state) => state.isLoading);
  const [startLoadingSync, setStartLoadingSync] = useState(false);
  const [activeSyncId, setActiveSyncId] = useState(0);
  const closeDialog = useDialogStore((state) => state.closeDialog);
  const openDialog = useDialogStore((state) => state.openDialog);

  const syncLocalWithPlayers = async (leagueId: number) => {
    if (startLoadingSync) return;
    setActiveSyncId(leagueId);
    setStartLoadingSync(true);
    await new Promise((resolve) => setTimeout(resolve, 300));
    try {
      const response = await axiosInstance.post('/sync-local-pccaddie', {
        registrationId: data?.registrationId,
        number_country: data?.number_country,
        date_start: data?.date_start,
        leagueId,
      });
      closeDialog();
      await new Promise((resolve) => setTimeout(resolve, 200));
      //openDialog(<LeagueReportEvents data={response.data} />, () => {}, true);
      openDialog(
        response.data.status !== 'success' ? (
          <div className="text-center mb-10">
            <div className="mx-auto my-4 relative flex items-center justify-center">
              <div className="mx-auto absolute w-52 z-10 flex gap-10 left-0 right-0">
                <div className="w-24 h-24 flex items-center justify-center bg-white/10 backdrop-blur-md shadow-lg rounded-md">
                  <img src={CloudIcon} alt="" className="w-auto" />
                </div>
                <div className="w-24 h-24 flex items-center justify-center bg-white/10 backdrop-blur-md shadow-lg rounded-md">
                  <img src={PccIcon} alt="" className="w-auto" />
                </div>
              </div>
              <img
                src={bgRingIcon}
                alt=""
                className="mx-auto animate-spin rounded-full"
                style={{ animation: 'spin 8s linear infinite' }}
              />
            </div>
            <div className="font-medium text-2xl">Operation fehlgeschlagen</div>
            <div>
              Die Möglichkeit, die Spieler mit der PCCADDIE Offline-Version zu
              synchronisieren, ist derzeit für dieses Turnier nicht verfügbar.
              Wenn Sie denken, dass dies ein unlogischer Fehler ist,
              kontaktieren Sie bitte den Support.
            </div>
          </div>
        ) : (
          <LeagueReportEvents data={response.data.data} />
        ),
        () => {},
        true,
      );
    } catch (error) {
      console.error('Error logging in:', error);
    } finally {
      setStartLoadingSync(false);
      setActiveSyncId(0);
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="text-center py-10 font-medium">
          <div className="text-5xl mb-6">⌛️</div>
          Bitte warten Sie einen Moment, während der Vorgang auf dem Server
          durchgeführt wird ...
        </div>
      ) : (
        <div className="text-left text-sm grid gap-0.5">
          <div className="flex items-center gap-4">
            <img className="hidden md:block" src={infoIcon} width={60} alt="" />
            <div>
              <div className="flex gap-2">
                <div className="text-neutral-500">Titel:</div>
                <div className="font-medium">{data?.title}</div>
              </div>
              <div className="flex gap-2">
                <div className="text-neutral-500">V-Ort:</div>
                <div className="font-medium">{data?.location}</div>
              </div>
              <div className="flex gap-2">
                <div className="text-neutral-500">Datum:</div>
                <div className="font-medium">{data?.date_start}</div>
              </div>
            </div>
          </div>
          <div className="h-0.5 bg-gray-200 my-4"></div>
          {data?.events.length === 0 ? (
            <div className="text-center mb-10">
              <div className="mx-auto my-4 relative flex items-center justify-center">
                <div className="mx-auto absolute w-52 z-10 flex gap-10 left-0 right-0">
                  <div className="w-24 h-24 flex items-center justify-center  backdrop-blur-sm shadow-lg rounded-md">
                    <img src={CloudIcon} alt="" className="w-auto" />
                  </div>
                  <div className="w-24 h-24 flex items-center justify-center backdrop-blur-sm shadow-lg rounded-md">
                    <img src={PccIcon} alt="" className="w-auto" />
                  </div>
                </div>
                <img
                  src={bgRingIcon}
                  alt=""
                  className="mx-auto animate-spin rounded-full"
                  style={{ animation: 'spin 8s linear infinite' }}
                />
              </div>
              <div className="font-medium text-2xl">Die Liste ist leer</div>
              <div>Es gibt keine Elemente zum Anzeigen</div>
            </div>
          ) : (
            <>
              {data?.events.length === 0 ? (
                <div className="py-10">
                  <NotFind
                    title="Nichts gefunden!"
                    description="Es gibt keine Liste zur Anzeige. Wenn Sie denken, dass dies ein Systemfehler ist, kontaktieren Sie bitte den Support."
                  />
                </div>
              ) : (
                <>
                  <div className="font-bold mb-3">
                    Bitte wählen Sie das Turnier, in das kopiert werden soll:
                  </div>
                  <div>
                    {data?.events.map((row) => (
                      <div
                        className={`${startLoadingSync && activeSyncId !== row.number && 'opacity-20'}  ${activeSyncId === row.number && 'md:shadow-2xl md:font-medium md:bg-neutral-900 md:text-white md:hover:bg-neutral-900 md:rounded-md md:scale-110 bg-white md:border-2 md:border-neutral-800 z-10'} flex px-2 border-b hover:bg-gray-100 gap-2 cursor-pointer items-center relative justify-between`}
                        key={row.id}
                        onClick={() => syncLocalWithPlayers(row.number)}
                      >
                        <div className="cursor-pointer flex">
                          <div className="flex items-center gap-2">
                            {startLoadingSync &&
                              activeSyncId === row.number && (
                                <img
                                  className="hidden md:block"
                                  src={ComputerIcon}
                                  alt=""
                                />
                              )}
                            {startLoadingSync && activeSyncId === row.number ? (
                              <img
                                src={SyncIcon}
                                className={
                                  startLoadingSync &&
                                  activeSyncId === row.number
                                    ? `animate-spin ml-1`
                                    : ''
                                }
                                alt=""
                              />
                            ) : (
                              <img src={SyncPlayerIcon} alt="sync player" />
                            )}

                            {startLoadingSync &&
                              activeSyncId === row.number && (
                                <img
                                  src={WebIcon}
                                  alt=""
                                  className="hidden md:block"
                                />
                              )}
                          </div>
                          <p className="py-2 inline-block font-medium ml-2">
                            {row.name}
                          </p>
                        </div>
                        <small className="hidden md:block">{row.date}</small>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default LeagueEvents;
